module.exports = __webpack_public_path__ + "static/undraw_programming-8c418e0179edc8fa382d7e10be10a782.svg";